//model-meta generated file
import {DateTime,ModelMeta,uuid} from '../../lib/model-meta';
import {WhereTable,RestTypes as _RestTypes} from '../../lib/model-meta';

export class Node{
	public id:number;
	public siteId:number=0;
	public type:string;
	public resourceId:number|null=null;
	public position:string;
	public dimension:string;
	public outputId:string|null=null;
	public inputId:string|null=null;
	public createdAt:DateTime=new DateTime();
}

export namespace Node{
	export const meta=new ModelMeta<keyof Props>(
		"Node",
		[],
		[
			{
				name: "id",
				type: "serial",
				decorators: {},
				uniqueKey: true,
				notNull: true
			},{
				name: "siteId",
				type: "int",
				decorators: {},
				default: 0,
				optional: true,
				notNull: true,
				comment: "setting siteId to default 0 everywhere so that it won't throw an error while creating siteId column in the database, need to change it later to not null and remove default value"
			},{
				name: "type",
				type: "string",
				decorators: {},
				notNull: true
			},{
				name: "resourceId",
				type: "number",
				decorators: {},
				default: null,
				optional: true
			},{
				name: "position",
				type: "string",
				decorators: {},
				notNull: true
			},{
				name: "dimension",
				type: "string",
				decorators: {},
				notNull: true
			},{
				name: "outputId",
				type: "string",
				decorators: {},
				default: null,
				optional: true
			},{
				name: "inputId",
				type: "string",
				decorators: {},
				default: null,
				optional: true
			},{
				name: "createdAt",
				type: "date",
				decorators: {
					"rest.readonly": true
				},
				default: "now()",
				optional: true,
				notNull: true
			}
		]
	);

	interface Props{
		id:number;
		siteId?:number;
		type:string;
		resourceId?:number|null;
		position:string;
		dimension:string;
		outputId?:string|null;
		inputId?:string|null;
		createdAt?:DateTime;
	}


	meta.generateRest("node",[
		{
			name: "email",
			type: "string",
			decorators: {}
		},{
			name: "authToken",
			type: "string",
			decorators: {}
		}
	]);

	export interface ReadableProps{
		id:number;
		siteId?:number;
		type:string;
		resourceId?:number|null;
		position:string;
		dimension:string;
		outputId?:string|null;
		inputId?:string|null;
		createdAt?:DateTime;
	}

	export interface ReadablePrimitiveProps{
		id:number;
		siteId?:number;
		type:string;
		resourceId?:number|null;
		position:string;
		dimension:string;
		outputId?:string|null;
		inputId?:string|null;
		createdAt?:DateTime;
	}

	namespace body{

		interface WritableProps{
			siteId?:number;
			type:string;
			resourceId?:number|null;
			position:string;
			dimension:string;
			outputId?:string|null;
			inputId?:string|null;
		}

		export interface Auth{
			email?:string;
			authToken?:string;
		}

		export interface Get extends Auth{
			where:number;
			fields?:(keyof ReadableProps)[];
		}

		export interface Put extends Auth{
			where:number;
			fields:Partial<WritableProps>;
		}

		export interface Post extends Auth{
			fields:Partial<WritableProps>;
		}

		export interface Delete extends Auth{
			where:number;
		}

		export interface Count extends Auth{
			where?:WhereTable<keyof ReadablePrimitiveProps>;
		}

		export interface Search extends Auth{
			fields?:(keyof ReadablePrimitiveProps)[];
			where?:WhereTable<keyof ReadablePrimitiveProps>;
			range?:[number,number];
			sort?:Partial<Record<keyof ReadablePrimitiveProps,'+'|'-'>>;
		}
	}

	namespace _response{
		export type Get=Partial<ReadableProps>;
		export type Search=Partial<ReadablePrimitiveProps>[];
	}

	export interface RestTypes extends _RestTypes{
		body:{
			Auth:body.Auth;
			Get:body.Get;
			Put:body.Put;
			Post:body.Post;
			Delete:body.Delete;
			Count:body.Count;
			Search:body.Search;
		}

		response: {
			Get:_response.Get;
			Search:_response.Search;
		}
	}

}
